import {PayloadAction} from '@reduxjs/toolkit';
import creativeTemplateBaseReducer from './creativeTemplateBase/creativeTemplateBase.slice';
import creativeTemplateHomeTabReducer from './creativeTemplateHomeTab/creativeTemplateHomeTab.slice';
import {CreativeTemplateBaseState} from './creativeTemplateBase/creativeTemplateBase.types';
import {CreativeTemplateHomeTabState} from './creativeTemplateHomeTab/creativeTemplateHomeTab.types';

export interface CreativeTemplatePageState extends CreativeTemplateBaseState {
  homeTab: CreativeTemplateHomeTabState;
}

// Custom reducer that flattens base properties while keeping other reducers nested
const creativeTemplatePageReducer = (
  state: CreativeTemplatePageState,
  action: PayloadAction,
): CreativeTemplatePageState => {
  const baseState = creativeTemplateBaseReducer(state, action);
  const homeTabState = creativeTemplateHomeTabReducer(state?.homeTab, action);

  return {
    ...baseState,
    homeTab: homeTabState,
  };
};

export default creativeTemplatePageReducer;
